import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CreateAccount() {
  const navigate = useNavigate();

  useEffect(() => {
    const acceptedTerms = localStorage.getItem('acceptedTerms');
    if (acceptedTerms !== 'true') {
      navigate('/terms-agreement');
    }
  }, [navigate]);

  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '2rem' }}>
      <h1>Create Account</h1>
      <p>Continue here to finish account creation after agreeing to the terms.</p>
    </main>
  );
}